// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var ReactIO = require("../../../shared/src/ReactIO.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var StripeTypes = require("../../../shared/src/bindings/StripeTypes.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var StripeJs = require("@stripe/stripe-js");
var Relude_Js_Promise = require("relude/src/js/Relude_Js_Promise.bs.js");
var ReactStripeJs = require("@stripe/react-stripe-js");

function card(param_0) {
  return /* Card */{
          _0: param_0
        };
}

function useElement(key, style, param) {
  var tmp = {};
  if (style !== undefined) {
    tmp.style = Caml_option.valFromOption(style);
  }
  if (key !== undefined) {
    tmp.key = Caml_option.valFromOption(key);
  }
  return [
          ReactStripeJs.CardElement,
          React.createElement(ReactStripeJs.CardElement, tmp)
        ];
}

function useElements(param) {
  return Relude_Globals.$great$great((function (prim) {
                return ReactStripeJs.useElements();
              }), (function (prim) {
                if (prim == null) {
                  return ;
                } else {
                  return Caml_option.some(prim);
                }
              }), param);
}

function getElement(elementHandle, t) {
  return t.getElement(elementHandle._0);
}

function getCardElement(param) {
  return Relude_Globals.$great$great(card, getElement, param);
}

function loadStripe(publicKey) {
  return StripeJs.loadStripe(publicKey);
}

function useStripe(param) {
  return Relude_Globals.$great$great((function (prim) {
                return ReactStripeJs.useStripe();
              }), (function (prim) {
                if (prim == null) {
                  return ;
                } else {
                  return Caml_option.some(prim);
                }
              }), param);
}

function originalPromiseRejected(param_0) {
  return {
          TAG: /* OriginalPromiseRejected */0,
          _0: param_0
        };
}

function tokenGet(param) {
  return Relude_Globals.$great$great((function (prim) {
                return prim.token;
              }), (function (prim) {
                if (prim == null) {
                  return ;
                } else {
                  return Caml_option.some(prim);
                }
              }), param);
}

function errorGet(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great((function (prim) {
                              return prim.error;
                            }), (function (prim) {
                              if (prim == null) {
                                return ;
                              } else {
                                return Caml_option.some(prim);
                              }
                            }), param);
              }), (function (param) {
                return Relude_Option.map(StripeTypes.$$Error.fromRawError, param);
              }), param);
}

function createCardToken(cardHandle, elements, t) {
  var lazyPromise = function (param) {
    return t.createToken(Curry._1(getCardElement(cardHandle), elements));
  };
  return Relude_IO.flatMap((function (result) {
                var match = Curry._1(tokenGet, result);
                var match$1 = Curry._1(errorGet, result);
                if (match !== undefined) {
                  if (match$1 !== undefined) {
                    return Relude_IO.$$throw(/* BothResultAndError */0);
                  } else {
                    return Relude_IO.pure(Caml_option.valFromOption(match));
                  }
                } else if (match$1 !== undefined) {
                  return Relude_IO.$$throw({
                              TAG: /* StripeError */1,
                              _0: match$1
                            });
                } else {
                  return Relude_IO.$$throw(/* NoResultOrError */1);
                }
              }), Curry._2(Relude_IO.mapError, originalPromiseRejected, Relude_Js_Promise.toIOLazy(lazyPromise)));
}

function BrowserBindings_ReactStripe$Internal(Props) {
  var children = Props.children;
  var stripe = useStripe(undefined);
  var elements = useElements(undefined);
  return Relude_Option.fold(null, (function (childProps) {
                return React.createElement(React.Fragment, {
                            children: Curry._1(children, childProps)
                          });
              }), Curry._2(Relude_Option.mapTuple2, (function (stripe, elements) {
                    return {
                            elements: elements,
                            stripe: stripe
                          };
                  }), [
                  stripe,
                  elements
                ]));
}

function BrowserBindings_ReactStripe(Props) {
  var children = Props.children;
  var stripePublicKey = Props.stripePublicKey;
  var driver = ReactIO.useMemo1(loadStripe, stripePublicKey);
  return React.createElement(ReactStripeJs.Elements, {
              children: React.createElement(BrowserBindings_ReactStripe$Internal, {
                    children: children
                  }),
              stripe: driver
            });
}

var CardElement = {
  useElement: useElement
};

var Elements = {
  getCardElement: getCardElement
};

var Stripe = {
  Token: {
    Create: {
      createCardToken: createCardToken
    }
  }
};

function makeProps(prim, prim$1, prim$2, prim$3) {
  var tmp = {
    children: prim,
    stripePublicKey: prim$1
  };
  if (prim$2 !== undefined) {
    tmp.key = Caml_option.valFromOption(prim$2);
  }
  return tmp;
}

var make = BrowserBindings_ReactStripe;

exports.CardElement = CardElement;
exports.Elements = Elements;
exports.Stripe = Stripe;
exports.makeProps = makeProps;
exports.make = make;
/* react Not a pure module */
